module.exports = __webpack_public_path__ + "img/rex-logo.f41a1bfa.png";